// src/modules/operaciones/inventarios/utils/api.js
//
// Cliente HTTP del módulo de Ajustes: fetch JSON con timeout y POST JSON.
import { TIMEOUT_FETCH_MS } from "./constantes"; // Tiempo máximo de espera por petición

// fetch JSON con timeout propio combinado con la signal externa (si hay). Un timeout se reporta como Error
// normal (no AbortError) para que los llamadores no lo traten como una cancelación silenciosa.
export const pedirJson = async (url, opciones) => {
  const ctrl = new AbortController(); // Controlador interno de cancelación
  const externa = opciones?.signal; // Signal opcional que viene del llamador
  const alAbortarExterna = () => ctrl.abort(); // Propaga la cancelación externa al controlador interno
  if (externa?.aborted) ctrl.abort(); // Si ya estaba cancelada, cancela de inmediato
  else externa?.addEventListener("abort", alAbortarExterna, { once: true }); // Si no, escucha su cancelación una vez

  let vencido = false; // Bandera que indica si venció el timeout
  const timer = setTimeout(() => {
    vencido = true; // Marca que fue por timeout
    ctrl.abort(); // Cancela la petición
  }, TIMEOUT_FETCH_MS); // Duración máxima de la petición

  try {
    const res = await fetch(url, { ...opciones, signal: ctrl.signal }); // Hace la petición con la signal combinada
    const texto = await res.text().catch((e) => { // Lee el cuerpo como texto
      if (ctrl.signal.aborted) throw e; // cancelado o vencido a mitad del cuerpo: no tratarlo como "sin JSON"
      return ""; // Otros fallos de lectura: cuerpo vacío
    });
    let data = {}; // Datos parseados por defecto vacíos
    try {
      data = texto ? JSON.parse(texto) : {}; // Parsea el JSON si hay texto
    } catch {
      /* la respuesta no era JSON */
    }
    if (!res.ok || !data.success) { // Falla si HTTP no es OK o el backend no marca success
      const detalle = data.error || texto.slice(0, 200) || `${res.status} ${res.statusText}`; // Arma el mensaje de error
      throw new Error(detalle || "Error de red"); // Lanza el error con el detalle
    }
    return data; // Devuelve los datos exitosos
  } catch (err) {
    if (vencido) throw new Error(`el servidor no respondió en ${TIMEOUT_FETCH_MS / 1000} s`); // Convierte el timeout en Error normal
    throw err; // Relanza cualquier otro error
  } finally {
    clearTimeout(timer); // Limpia el temporizador
    externa?.removeEventListener("abort", alAbortarExterna); // Quita el listener de la signal externa
  }
};

// POST JSON: envía body serializado con cabecera de contenido y signal opcional
export const postJson = (url, body, signal) =>
  pedirJson(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), signal });